import { render, staticRenderFns } from "./Breadcrumb.vue?vue&type=template&id=1ab22fbd&scoped=true"
import script from "@/controllers/componentHooks/breadcrumb/index.js?vue&type=script&lang=js&external"
export * from "@/controllers/componentHooks/breadcrumb/index.js?vue&type=script&lang=js&external"
import style0 from "./Breadcrumb.scss?vue&type=style&index=0&id=1ab22fbd&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab22fbd",
  null
  
)

export default component.exports